export default [
  [
    {
      id: 'isActive',
      type: 8,
      span: 2,
      offset: 22,
      props: { padding: '8px 0', width: '100%', title: { text: 'รหัสปั๊มน้ำมัน *' } },
    }, {
      id: 'code',
      type: 0,
      span: 6,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'รหัสปั๊มน้ำมัน *' } },
    }, {
      id: 'name',
      type: 0,
      span: 12,
      offset: 6,
      props: { padding: '8px 0', width: '100%', title: { text: 'ชื่อสถานี *' } },
    }, {
      id: 'company',
      type: 5,
      span: 6,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'บริษัท *' } },
    }, {
      id: 'contactnumber',
      type: 0,
      span: 12,
      offset: 6,
      props: { padding: '8px 0', width: '100%', title: { text: 'เบอร์โทรศัพท์' } },
    }, {
      id: 'taxId',
      type: 0,
      span: 6,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เลขผู้เสียภาษี' } },
    }, {
      id: 'creditTerm',
      type: 0,
      span: 6,
      offset: 6,
      props: { padding: '8px 0', width: '100%', title: { text: 'ระยะเครดิต' } },
    }, {
      id: 'email',
      type: 0,
      span: 12,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'อีเมลล์' } },
    }, {
      id: 'officialName',
      type: 0,
      span: 12,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ชื่อทางการ' } },
    },
  ], [
    {
      id: 'remark',
      label: 'หมายเหตุ',
      span: 12,
      type: 6,
      props: { rows: 4 },
    },
  ], [
    {
      id: 'images',
      span: 24,
      type: 7,
      props: { margin: '8px 0' },
    },
  ],
]
